import { jsx } from 'react/jsx-runtime';
import { styled } from '@flex-design-system/stitches-react';
import { assignInlineVars } from '@vanilla-extract/dynamic';
import classNames from 'classnames';
import { getColor } from '../../utils/colors.mjs';
import { isPresetSize } from '../../utils/size.mjs';
import { spinnerStyle, spinnerSize, rotateStyle } from './spinner.vanilla.mjs';

function SpinnerImpl({
  className: classNameFromProps,
  style: styleFromProps,
  color: colorFromProps = "grayLight",
  size: sizeFromProps = "default",
  ...props
}) {
  const color = getColor(colorFromProps);
  const className = classNames(
    spinnerStyle({
      size: isSpinnerPresetSize(sizeFromProps) ? sizeFromProps : "default"
    }),
    classNameFromProps
  );
  const style = isSpinnerPresetSize(sizeFromProps) ? styleFromProps : Object.assign(
    assignInlineVars({
      [spinnerSize]: typeof sizeFromProps === "string" ? sizeFromProps : `${sizeFromProps}px`
    }),
    styleFromProps
  );
  return /* @__PURE__ */ jsx("div", { className, style, ...props, children: /* @__PURE__ */ jsx("div", { className: rotateStyle, children: /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(
    "circle",
    {
      cx: "12",
      cy: "12",
      r: "8",
      fill: "none",
      strokeWidth: "1.88",
      strokeLinecap: "round",
      strokeDasharray: "25.132741228718345 12.566370614359172 50.26548245743669",
      stroke: color
    }
  ) }) }) });
}
const isSpinnerPresetSize = (size) => {
  return isPresetSize(size) && !["xsmall", "xlarge"].includes(size);
};
const Spinner = styled(SpinnerImpl);

export { Spinner };
//# sourceMappingURL=Spinner.mjs.map
